import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GeocodingApiService {
  API_KEY: string;
  API_URL: string;

  constructor(private http: HttpClient) {
    this.API_KEY = 'AIzaSyAkE5arCqIim54RFZAf-8ps2lw2f-clxRE';
    this.API_URL = `https://maps.googleapis.com/maps/api/geocode/json?key=${this.API_KEY}&address=`;
  }

  findFromAddress(address: string, postalCode?: string, place?: string, province?: string, region?: string, country?: string): Observable<any> {
    let compositeAddress = [address];

    if (postalCode) compositeAddress.push(postalCode);
    if (place) compositeAddress.push(place);
    if (province) compositeAddress.push(province);
    if (region) compositeAddress.push(region);
    if (country) compositeAddress.push(country);

    let url = `${this.API_URL}${compositeAddress.join(',')}`;

    return this.http.get(url).pipe(
      map(response => <any>response)
    )
  }

  

  getDistanceBetweenAdresses(address1, address2) {    
    
    let url = `https://maps.googleapis.com/maps/api/directions/json?origin=${address1}&destination=${address2}&key=${this.API_KEY}`;

    return this.http.get(url).pipe(
      map(response => <any>response)
    )
  }

}